import { cva } from 'class-variance-authority';
const root = cva(['flex w-full touch-none select-none items-center group'], {
    variants: {
        size: {
            sm: 'gap-slider-sm-x',
            md: 'gap-slider-md-x',
        },
        variant: {
            brand: '',
            default: '',
        },
    },
    defaultVariants: {
        size: 'md',
        variant: 'default',
    },
});
const range = cva(['absolute h-full'], {
    variants: {
        size: {
            sm: '',
            md: '',
        },
        variant: {
            brand: 'bg-slider-loading-brand',
            default: 'bg-slider-loading-neutral',
        },
    },
    defaultVariants: {
        size: 'md',
        variant: 'default',
    },
});
const track = cva([
    'relative w-full grow overflow-hidden rounded-slider-rounded bg-slider-background group-hover:bg-slider-background-hover',
    'transition-colors duration-200 ease-in-out',
], {
    variants: {
        size: {
            sm: 'h-slider-bar-sm',
            md: 'h-slider-bar-md',
        },
    },
    defaultVariants: {
        size: 'md',
    },
});
const thumb = cva([
    'block rounded-slider-rounded shadow-slider',
    'focus-visible:outline-none',
    'transition-all duration-150 ease-in-out',
    'ring-offset-[0px]',
    'hover:ring-offset-[3px] active:ring-offset-[3px] focus-visible:ring-offset-[3px]',
    'ring-slider ring-transparent focus-visible:ring-slider-focus',
    'hover:ring-slider-hover active:ring-slider-press',
    'ring-offset-[var(--color-bg)]',
    'disabled:pointer-events-none disabled:opacity-50',
    'bg-slider-handle',
    'cursor-grab active:cursor-grabbing',
], {
    variants: {
        size: {
            sm: 'h-slider-handle-sm w-slider-handle-sm active:h-slider-handle-sm-press active:w-slider-handle-sm-press',
            md: 'h-slider-handle-md w-slider-handle-md active:h-slider-handle-md-press active:w-slider-handle-md-press',
        },
    },
    defaultVariants: {
        size: 'md',
    },
});
const icon = cva(['icon-slider-primary group-disabled:icon-slider-disabled-alpha flex-shrink-0'], {
    variants: {
        size: {
            sm: 'h-slider-icon-sm w-slider-icon-sm',
            md: 'h-slider-icon-md w-slider-icon-md',
        },
    },
    defaultVariants: {
        size: 'md',
    },
});
export const styles = {
    root,
    icon,
    range,
    track,
    thumb,
};
